import { jsx as _jsx } from "react/jsx-runtime";
// TODO(sap-sync-flag): delete this when the SAP sync feature flag is removed
import Badge from "@iscr/views/NUI/Badge";
import { cls } from "@iscr/views/NUI/utils";
import { SAP_SYNC_LEVEL_LABELS } from "./model";
// Kept clear of the SAP Status badge colours (see SyncStateCell) so the two columns don't read as one, and
// of reds so nothing here reads as an error. Badge has no orange, so it's applied as an override.
const LEVEL_STYLES = {
    off: { color: "gray" },
    profile: { color: "gray", className: "!bg-orange-100 !text-orange-800" },
    invoices: { color: "gray", className: "!bg-orange-200 !text-orange-800" },
};
// Sized like the SAP Status badge, but squarer so it doesn't look like another status. Badge's own
// `rounded-full` isn't merged away, so the override needs `!`.
export const SapSyncLevelBadge = ({ level }) => (_jsx(Badge, { color: LEVEL_STYLES[level].color, small: true, className: cls("whitespace-nowrap !rounded-md", LEVEL_STYLES[level].className), children: SAP_SYNC_LEVEL_LABELS[level] }));
